import baseAxios from "./base";

const publicAxiosInstance = baseAxios;

export default publicAxiosInstance;
